
async function base64url(input) {
  let bin = "";
  const arr = new Uint8Array(input);
  for (let i = 0; i < arr.length; i++) bin += String.fromCharCode(arr[i]);
  return btoa(bin).replace(/=+$/, "").replace(/\+/g, "-").replace(/\//g, "_");
}

async function hmacSha256(key, msg) {
  const enc = new TextEncoder();
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    enc.encode(key),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );
  const sig = await crypto.subtle.sign("HMAC", cryptoKey, enc.encode(msg));
  return new Uint8Array(sig);
}

async function base64urlEncodeUtf8(str) {
  const bytes = new TextEncoder().encode(str);
  return await base64url(bytes);
}

export async function buildJwt(claims = {}) {
  const secret = process.env.REACT_APP_JWT_SECRET;
  const iss = process.env.REACT_APP_JWT_ISS || window.location.origin;
  const aud = process.env.REACT_APP_JWT_AUD;

  if (!secret) {
    throw new Error("Missing REACT_APP_JWT_SECRET");
  }

  const now = Math.floor(Date.now() / 1000);

  const payload = {
    iss,
    aud,
    iat: now,
    nbf: now - 5,
    exp: now + 3600,
    sub: "bayer-frontend",
    ...claims,
  };

  const headerB64 = await base64urlEncodeUtf8(JSON.stringify({ alg: "HS256", typ: "JWT" }));
  const payloadB64 = await base64urlEncodeUtf8(JSON.stringify(payload));

  const signingInput = `${headerB64}.${payloadB64}`;
  const sigBytes = await hmacSha256(secret, signingInput);
  const signatureB64 = await base64url(sigBytes);

  return `${signingInput}.${signatureB64}`;
}